<style>
@import url("https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css");
</style>
  <template>
  <ScrollProgressBar :color="'bright-sky-blue'">
    <div class="main-container project dominos">
      <Menu
        :hamburgerColor="this.activeSectionMenuColor"
        :showChild="showChild"
        :title="sections[activeSectionTitle].title"
        :dot="sections[activeSectionTitle].dot"
        :textColor="sections[activeSectionTitle].textColor"
        :agency="sections[activeSectionTitle].agency"
        :client="sections[activeSectionTitle].client"
        :role="sections[activeSectionTitle].role"
        :url="sections[activeSectionTitle].url"
        :subtitle="sections[activeSectionTitle].subtitle"
        :specificationColor="sections[activeSectionTitle].specificationColor"
        @changeActiveSection="activeSection = $event"
        class="fixed-top pizza"
      />

      <!-- First section -->
      <section class="section__project intro">
        <div class="main-container__logo fixed-top">
          <div>
            <router-link to="/" aria-label="intervi logo">
              <svg
                width="109px"
                height="19px"
                viewBox="0 0 109 19"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <defs>
                  <polygon
                    id="path-1"
                    points="0 0.385902439 5.90810769 0.385902439 5.90810769 17.9477561 0 17.9477561"
                  />
                  <polygon
                    id="path-3"
                    points="0.000230769231 0.325714286 17.7233077 0.325714286 17.7233077 17.9491286 0.000230769231 17.9491286"
                  />
                  <polygon
                    id="path-5"
                    points="0.0345857143 0.335813953 17.8631571 0.335813953 17.8631571 18.9998674 0.0345857143 18.9998674"
                  />
                  <polygon
                    id="path-7"
                    points="0.35506875 0.03138 5.8695 0.03138 5.8695 5.91358 0.35506875 5.91358"
                  />
                </defs>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="NEW-NEW-contact" transform="translate(-276.000000, -56.000000)">
                    <g id="Group-21" transform="translate(276.000000, 56.000000)">
                      <g id="Group-3">
                        <mask id="mask-2" fill="white">
                          <use xlink:href="#path-1" />
                        </mask>
                        <g id="Clip-2" />
                        <path
                          d="M5.90810769,0.859170732 L5.90810769,17.4744878 C5.90810769,17.7357073 5.68564615,17.9477561 5.41056923,17.9477561 L0.497492308,17.9477561 C0.222876923,17.9477561 -4.61538462e-05,17.7357073 -4.61538462e-05,17.4744878 L-4.61538462e-05,0.859170732 C-4.61538462e-05,0.597512195 0.222876923,0.385902439 0.497492308,0.385902439 L5.41056923,0.385902439 C5.68564615,0.385902439 5.90810769,0.597512195 5.90810769,0.859170732"
                          id="Fill-1"
                          fill="#000000"
                          mask="url(#mask-2)"
                        />
                      </g>
                      <g id="Group-6" transform="translate(9.000000, 0.000000)">
                        <mask id="mask-4" fill="white">
                          <use xlink:href="#path-3" />
                        </mask>
                        <g id="Clip-5" />
                        <path
                          d="M17.7233077,7.42298571 L17.7233077,17.4867 C17.7233077,17.7421286 17.5008462,17.9491286 17.2257692,17.9491286 L12.6823846,17.9491286 C12.4073077,17.9491286 12.1848462,17.7421286 12.1848462,17.4867 L12.1848462,8.17727143 C12.1848462,6.05112857 10.7448462,5.05684286 8.97253846,5.05684286 C6.94176923,5.05684286 5.53869231,6.15398571 5.53869231,8.5887 L5.53869231,17.4867 C5.53869231,17.7421286 5.31576923,17.9491286 5.04069231,17.9491286 L0.497769231,17.9491286 C0.222692308,17.9491286 0.000230769231,17.7421286 0.000230769231,17.4867 L0.000230769231,1.26741429 C0.000230769231,1.01198571 0.222692308,0.805414286 0.497769231,0.805414286 L5.04069231,0.805414286 C5.31576923,0.805414286 5.53869231,1.01198571 5.53869231,1.26741429 C5.53869231,1.65227143 6.02146154,1.87512857 6.34130769,1.62955714 C7.39961538,0.8187 8.93192308,0.325414286 10.8186923,0.325414286 C14.5479231,0.325414286 17.7233077,2.79398571 17.7233077,7.42298571"
                          id="Fill-4"
                          fill="#000000"
                          mask="url(#mask-4)"
                        />
                      </g>
                      <path
                        d="M36.9355129,1 L38.7299651,5.47259445 C38.8571375,5.79056622 38.6420179,6.14515833 38.3211967,6.14515833 L36.0428287,6.14515833 C35.7967419,6.14515833 35.5977253,6.36086109 35.5977253,6.62702846 L35.5977253,12.4693131 C35.5977253,13.892594 36.6477234,14.1199081 38.5367291,14.0314834 C38.7885965,14.0194255 39,14.2395941 39,14.5120137 L39,18.4250315 C39,18.6737819 38.8216283,18.8845721 38.5924703,18.906455 C32.4460794,19.487468 30.6429563,17.3643813 30.6429563,12.4693131 L30.6429563,6.62702846 C30.6429563,6.36086109 30.4435269,6.14515833 30.1978529,6.14515833 L28.4455163,6.14515833 C28.1994295,6.14515833 28,5.92990216 28,5.66373478 L28,1"
                        id="Fill-7"
                        fill="#000000"
                      />
                      <g id="Group-11" transform="translate(41.000000, 0.000000)">
                        <mask id="mask-6" fill="white">
                          <use xlink:href="#path-5" />
                        </mask>
                        <g id="Clip-10" />
                        <path
                          d="M12.0975857,7.82963488 C12.4391571,7.82963488 12.6564429,7.46244884 12.5137286,7.1421 C11.8327286,5.61105349 10.4763,5.0375186 9.1203,5.0375186 C7.43001429,5.0375186 6.22744286,5.77675116 5.62272857,7.14254186 C5.48087143,7.4628907 5.69687143,7.82963488 6.03844286,7.82963488 L12.0975857,7.82963488 Z M9.6003,14.2635651 C10.8615857,14.2635651 11.9574429,13.808007 12.6641571,13.1527279 C12.8098714,13.0175186 13.0241571,12.9985186 13.1943,13.0997047 L16.5487286,15.0880767 C16.7908714,15.2312395 16.8615857,15.5674953 16.6850143,15.7910767 C15.0101571,17.9106814 12.5878714,18.9998674 9.53172857,18.9998674 C3.66844286,18.9998674 0.0345857143,14.935193 0.0345857143,9.66777442 C0.0345857143,4.40035581 3.73701429,0.335681395 9.15458571,0.335681395 C14.1598714,0.335681395 17.8631571,4.3301 17.8631571,9.66777442 C17.8631571,10.2682628 17.8185857,10.8448907 17.7290143,11.3985419 C17.6921571,11.6256581 17.4954429,11.7887047 17.2717286,11.7887047 L6.22272857,11.7887047 C5.86187143,11.7887047 5.63558571,12.2000767 5.8263,12.5151233 C6.60201429,13.798286 7.98844286,14.2635651 9.6003,14.2635651 Z"
                          id="Fill-9"
                          fill="#000000"
                          mask="url(#mask-6)"
                        />
                      </g>
                      <path
                        d="M71.5127354,1.43557822 L72.9775077,6.07079646 C73.078264,6.39163042 72.827045,6.70436478 72.4925342,6.69176541 C70.290226,6.60671966 67.3736678,7.65651717 67.3736678,10.8639568 L67.3736678,18.5149243 C67.3736678,18.7831108 67.1573777,19 66.8909333,19 L62.4827345,19 C62.2158423,19 62,18.7831108 62,18.5149243 L62,1.48507575 C62,1.21733913 62.2158423,1 62.4827345,1 L66.8909333,1 C67.1573777,1 67.3736678,1.21733913 67.3736678,1.48507575 L67.3736678,2.01379931 C67.3736678,2.47232638 67.9602932,2.69101545 68.2352459,2.32518374 C68.8711299,1.47832608 69.7416641,1.14579271 71.0434351,1.09719514 C71.2570384,1.08909555 71.4478036,1.23083846 71.5127354,1.43557822"
                        id="Fill-12"
                        fill="#000000"
                      />
                      <path
                        d="M91.9711609,1.65336733 L86.0071913,18.6832158 C85.9403239,18.8735563 85.7686836,19 85.5761738,19 L80.4235562,19 C80.2318982,19 80.0594061,18.8735563 79.9929647,18.6832158 L74.028995,1.65336733 C73.9178334,1.33658317 74.1401566,1 74.4595866,1 L79.1236894,1 C79.3221618,1 79.4980612,1.13454327 79.5598177,1.33388331 L82.5637367,11.0070496 C82.7017304,11.4520774 83.2979996,11.4520774 83.4364192,11.0070496 L86.4403382,1.33388331 C86.5016688,1.13454327 86.6775682,1 86.8764666,1 L91.5401435,1 C91.8599993,1 92.0818966,1.33658317 91.9711609,1.65336733"
                        id="Fill-14"
                        fill="#000000"
                      />
                      <path
                        d="M95.4491667,1 L99.5508333,1 C99.79875,1 100,1.21688916 100,1.48507575 L100,18.5149243 C100,18.7831108 99.79875,19 99.5508333,19 L95.4491667,19 C95.2008333,19 95,18.7831108 95,18.5149243 L95,1.48507575 C95,1.21688916 95.2008333,1 95.4491667,1"
                        id="Fill-16"
                        fill="#000000"
                      />
                      <g id="Group-20" transform="translate(103.000000, 13.000000)">
                        <mask id="mask-8" fill="white">
                          <use xlink:href="#path-7" />
                        </mask>
                        <g id="Clip-19" />
                        <path
                          d="M1.7659125,5.32108 L0.9105375,4.40868 C0.1699125,3.61868 0.1699125,2.32628 0.9105375,1.53588 L1.7659125,0.62388 C2.5065375,-0.16612 3.7181625,-0.16612 4.4587875,0.62388 L5.3141625,1.53588 C6.0547875,2.32628 6.0547875,3.61868 5.3141625,4.40868 L4.4587875,5.32108 C3.7181625,6.11108 2.5065375,6.11108 1.7659125,5.32108"
                          id="Fill-18"
                          fill="#000000"
                          mask="url(#mask-8)"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </router-link>
          </div>
        </div>
        <div class="section-box">
          <ComponentPizzaBox />
          <FloatingSocials :hoverColor="projects[4].dot" />
          <FloatingText />
          <div class="row col-sm-12">
            <div class="col-xs-12 col-md-6 title__box">
              <h2
                v-bind:style="{color: projects[4].textColor }"
                style="transform: matrix(1, 0, 0, 1, 0, 0);"
              >
                <img
                  src="../assets/project-logos/pizzabox_logo_sygnet.svg"
                  alt="dominos logo"
                  class="logo-intro"
                  data-aos="fade-up"
                />
                Our homage
                <br />to pizza
                <span v-bind:style="{color: projects[4].dot }">.</span>
              </h2>
              <div class="scroll-down">
                <span style="transform: matrix(1, 0, 0, 1, 0, 0);">
                  <span class="mouse">
                    <svg
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 512 512"
                      style="enable-background:new 0 0 512 512;"
                      xml:space="preserve"
                    >
                      <g>
                        <g>
                          <path
                            d="M256,140.15c-9.364,0-16.954,7.59-16.954,16.954v59.338c0,9.364,7.59,16.954,16.954,16.954
                              c9.364,0,16.954-7.59,16.954-16.954v-59.338C272.954,147.74,265.364,140.15,256,140.15z"
                          />
                        </g>
                      </g>
                    </svg>
                    <svg
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 512 512"
                      style="enable-background:new 0 0 512 512;"
                      xml:space="preserve"
                    >
                      <g>
                        <g>
                          <path
                            d="M256,0C156.595,0,75.726,82.14,75.726,183.099v145.807C75.726,429.865,156.595,512,256,512
                              c99.399,0,180.274-81.886,180.274-182.534V183.099C436.274,82.14,355.399,0,256,0z M402.366,329.466
                              c0,81.954-65.656,148.627-146.366,148.627c-80.705,0-146.366-66.927-146.366-149.192V183.099
                              c0-82.265,65.661-149.192,146.366-149.192c80.711,0,146.366,66.927,146.366,149.192V329.466z"
                          />
                        </g>
                      </g>
                    </svg>
                  </span>
                  <span>Scroll down</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Description section -->
      <section class="section__project description">
        <div class="section-box title__box">
          <FloatingSocials :hoverColor="projects[4].dot" />
          <FloatingText />
          <!-- <FloatingContact /> -->

          <div class="text-container">
            <h2 data-aos="fade-up">
              PizzaBox.
              <br />Delivery App Concept
            </h2>

            <div class="specification" data-aos="fade-up">
              <ul>
                <li class="text-wrap text-wrap__small">
                  <span style="transform: matrix(1, 0, 0, 1, 0, 0);">Agency</span>
                </li>
                <li class="text-wrap text-wrap__small">
                  <span style="transform: matrix(1, 0, 0, 1, 0, 0);">{{ projects[4].agency }}</span>
                </li>
              </ul>
              <ul>
                <li class="text-wrap text-wrap__small">
                  <span style="transform: matrix(1, 0, 0, 1, 0, 0);">Client</span>
                </li>
                <li class="text-wrap text-wrap__small">
                  <span style="transform: matrix(1, 0, 0, 1, 0, 0);">{{ projects[4].client }}</span>
                </li>
              </ul>
              <ul>
                <li class="text-wrap text-wrap__small">
                  <span style="transform: matrix(1, 0, 0, 1, 0, 0);">Role</span>
                </li>
                <li class="text-wrap text-wrap__small">
                  <span style="transform: matrix(1, 0, 0, 1, 0, 0);">{{ projects[4].role }}</span>
                </li>
              </ul>
            </div>

            <p
              class="text-standard"
              data-aos="fade-up"
            >We love pizza and pizza loves us in return. The result of this mutual affection and tribute to pizza is our idea for the look and functionality of an application for the popular Domino's Pizza chain. It maintains a clean and extremely minimalist style. This makes the app correspond to the temperament of the creators of the best pizza in the world.</p>
            <div class="row lists" data-aos="fade-up">
              <ul class="col-xs-12 col-sm-6 col-md-3 pb-4">
                <span>UX Design</span>
                <li v-for="item in projects[4].UXDesign">{{ item }}</li>
              </ul>
              <ul class="col-xs-12 col-sm-6 col-md-3 pb-4">
                <span>Interface Design</span>
                <li v-for="item in projects[4].InterfaceDesign">{{ item }}</li>
              </ul>
              <ul class="col-xs-12 col-sm-6 col-md-3 pb-4">
                <span>Branding</span>
                <li v-for="item in projects[4].Branding">{{ item }}</li>
              </ul>
              <ul class="col-xs-12 col-sm-6 col-md-3 pb-4">
                <span>Credits</span>
                <li v-for="item in projects[4].Credits">{{ item }}</li>
              </ul>
            </div>
            <CaseContact data-aos="fade-up" />
          </div>
        </div>
      </section>

      <!-- Other information -->
      <section class="section__project other">
        <div class="other__padding">
          <picture>
            <source
              media="(max-width: 1440px) and (max-resolution: 192dpi)"
              data-srcset="https://ik.imagekit.io/intervi/dominos-bg-2x_rkg3DbC7wE.png"
            />
            <img
              src="https://ik.imagekit.io/intervi/tr:bl-7/dominos-bg-2x_rkg3DbC7wE.png"
              data-src="https://ik.imagekit.io/intervi/dominos-bg-2x_rkg3DbC7wE.png"
              class="img-full lazyload"
              alt="screen photo"
              data-aos="fade-up"
            />
          </picture>
        </div>

        <div class="position-relative">
          <div class="title__box other__padding">
            <div class="other__text pb-0">
              <h2 data-aos="fade-up">An aromatic application</h2>
            </div>
            <div class="row other__text" data-aos="fade-up">
              <p
                class="text-standard col-xs-12 col-md-6"
              >We wanted to create an application that would be as appetizing as Domino’s pizza. This is why our creation is dominated by photos of a great-looking pizza that make you want to place an order right away!</p>
              <p
                class="text-standard col-xs-12 col-md-6"
              >Aromatic herbs, spices and toppings, which should be included on every pizza, are a nice addition for the eyes and palate alike.</p>
            </div>
          </div>
        </div>

        <div class="other__padding row" data-aos="fade-up">
          <div class="col-xs-12 col-lg-6">
            <h2 class="other__line"></h2>
          </div>
          <div class="col-xs-12 col-lg-6 title__box">
            <h2 class="other__padding2 letter__spacing-1">
              App Screens
              <br />
              <span v-bind:style="{ 'color': '#cacaca'}">on Mobile</span>
            </h2>
          </div>
        </div>

        <div class="other__padding row">
          <div class="col-xs-12 col-lg-6">
            <video width="400" controls autoplay loop muted data-aos="fade-up">
              <source
                src="https://ik.imagekit.io/intervi/video/funkcjonalnoscaplikacji_ByWWZ6qTV.mp4"
                type="video/mp4"
              />Your browser does not support HTML5 video.
            </video>
          </div>
          <div class="col-xs-12 col-lg-6 title__box other__text">
            <h2 data-aos="fade-up">Our world revolves around pizza!</h2>
            <p
              class="text-standard"
              data-aos="fade-up"
            >Every pizza lover knows that pizzas are special enough to need a special setting. We believe that a good product speaks for itself, so there is no point in creating a stylistically complex application. It should be simple, aesthetic and tasteful.</p>
            <p
              class="text-standard"
              data-aos="fade-up"
            >We refer to obvious associations, such as the wooden table on which the delicious pizza is served, and the colorful herbs and spices that are essential for that perfect pizza flavor.</p>
          </div>
        </div>

        <div class="other__padding">
          <img
            class="other__padding img-full lazyload"
            src="https://ik.imagekit.io/intervi/tr:bl-7/dominos-bg2_Skz8vZA7PV.jpg"
            data-src="https://ik.imagekit.io/intervi/dominos-bg2_Skz8vZA7PV.jpg"
            alt="pizza"
            data-aos="fade-up"
          />
        </div>

        <!-- <div class="other__padding">
        <img
          class="other__padding img-full"
          src="../assets/dominos-bg2.jpg"
          alt="pizza"
          data-aos="fade-up"
        >
        </div>-->

        <div class="other__padding row">
          <div class="col-xs-12 col-lg-6 title__box other__text">
            <h2 data-aos="fade-up">Create your own pizza!</h2>
            <p
              class="text-standard"
              data-aos="fade-up"
            >This modern application for the Domino's Pizza chain allows you to freely combine and mix toppings with the help of a special creator tool. You start by choosing the size, then the application prompts you to choose sauces, and finally to select the toppings.</p>
            <p
              class="text-standard"
              data-aos="fade-up"
            >Intuitive and easy to navigate, this application provides limitless ways to create pizza and mix in the toppings you enjoy most.</p>
          </div>
          <div class="col-xs-12 col-lg-6" data-aos="fade-up">
            <video width="400" controls autoplay loop muted data-aos="fade-up">
              <source
                src="https://ik.imagekit.io/intervi/video/buildpizzadark_444_SkroeacaE.mp4"
                type="video/mp4"
              />Your browser does not support HTML5 video.
            </video>
          </div>
        </div>
        <div class="other__padding row">
          <div class="col-xs-12 col-lg-6 title__box other__text order-lg-2">
            <h2 data-aos="fade-up">Cashless payment transactions!</h2>
            <p
              class="text-standard"
              data-aos="fade-up"
            >If you already know what kind of pizza you want, you can also decide how to pay for it. Simply select the payment method and confirm the transaction with the Touch ID function.</p>
            <p
              class="text-standard"
              data-aos="fade-up"
            >This is a simple, fast and completely safe way to buy your favorite pizza at any time.</p>
          </div>
          <div class="col-xs-12 col-lg-6 order-lg-1">
            <video width="400" controls autoplay loop muted data-aos="fade-up">
              <source
                src="https://ik.imagekit.io/intervi/video/ShoppingCart_BkoDbAQwE.mp4"
                type="video/mp4"
              />Your browser does not support HTML5 video.
            </video>
          </div>
        </div>

        <!-- Hand -->
        <div class="position-relative other__hand-box">
          <div class="row col-sm-12 h-100">
            <div class="col-xs-12 col-lg-6 title__box other__text">
              <h2 data-aos="fade-up">Unique creator tool</h2>
              <p
                class="text-standard"
                data-aos="fade-up"
              >The biggest advantage of the application is the unique creator tool, enabling any combination of toppings. This ensures that you always get exactly what you want.</p>
              <p
                class="text-standard"
                data-aos="fade-up"
              >The application gives you a preview of the appearance of the crust and toppings, so you can control not only the taste, but also what your pizza looks like.</p>
            </div>
            <div class="col-xs-12 col-lg-6"></div>
          </div>
          <img
            src="https://ik.imagekit.io/intervi/tr:bl-7/dominos-screen4-2x_B1pD-RQDV.png"
            data-src="https://ik.imagekit.io/intervi/dominos-screen4-2x_B1pD-RQDV.png"
            alt="hand with mobile"
            data-aos="fade-up"
            class="hand lazyload"
          />
          <picture>
            <source
              media="(max-width: 1440px) and (max-resolution: 192dpi)"
              data-srcset="https://ik.imagekit.io/intervi/dominos-bg3-1x_SJGi8bAXDV.jpg"
            />
            <img
              src="https://ik.imagekit.io/intervi/tr:bl-7/dominos-bg3-2x_S1WjPbRQwV.jpg"
              data-src="https://ik.imagekit.io/intervi/dominos-bg3-2x_S1WjPbRQwV.jpg"
              class="other__lights img-full lazyload"
              alt="background lights"
            />
          </picture>
        </div>

        <!-- Videos -->
        <div class="other__ideo-section d-flex justify-content-around">
          <video width="800" controls autoplay loop muted data-aos="fade-up">
            <source
              src="https://ik.imagekit.io/intervi/video/pizzashot_BJeAwbRmD4.mp4"
              type="video/mp4"
            />Your browser does not support HTML5 video.
          </video>
          <video width="800" controls autoplay loop muted data-aos="fade-up">
            <source src="https://ik.imagekit.io/intervi/video/1_Skq8WRXv4.mp4" type="video/mp4" />Your browser does not support HTML5 video.
          </video>
        </div>

        <!-- Pizza man -->
        <div class="position-relative other__pizza-man position-relative" data-aos="fade-up">
          <img
            src="https://ik.imagekit.io/intervi/tr:w-993,bl-7/dominos-pizza-slice_H1-v-AQvV.png"
            data-src="https://ik.imagekit.io/intervi/tr:w-993/dominos-pizza-slice_H1-v-AQvV.png"
            alt="pizza slice"
            class="pizza1 lazyload"
            data-aos="fade-down-left"
            data-aos-offset="250"
          />
          <img
            src="https://ik.imagekit.io/intervi/tr:w-993,bl-7/dominos-pizza-slice_H1-v-AQvV.png"
            data-src="https://ik.imagekit.io/intervi/tr:w-993/dominos-pizza-slice_H1-v-AQvV.png"
            alt="pizza slice"
            class="pizza2 lazyload"
            data-aos="fade-down-right"
          />
          <img
            src="https://ik.imagekit.io/intervi/tr:bl-7/pizza_guy_iv_2x_HyqJ8ndKV.png"
            data-src="https://ik.imagekit.io/intervi/pizza_guy_iv_2x_HyqJ8ndKV.png"
            alt="pizza delivery"
            class="pizza-man lazyload"
            data-aos="fade-up"
          />
          <img
            src="../assets/project-logos/pizzabox_logo_sygnet.svg"
            alt="dominos logo"
            class="logo"
            data-aos="fade-up"
          />
          <div class="row col-sm-12">
            <div class="col-xs-12 col-lg-6"></div>
            <div class="col-xs-12 col-lg-6 title__box pl-5">
              <h2 data-aos="fade-up">
                Domino's pizza
                <br />delivery application
              </h2>
              <h2 data-aos="fade-up">by Intervi</h2>
            </div>
          </div>
        </div>
      </section>

      <!-- Navigation -->
      <section class="section__project nav">
        <div class="section-box">
          <div class="title__box w-100">
            <h2>
              <router-link to="/project-mercedes" style="float: left;">Previous</router-link>
              <router-link to="project-nykart" style="float: right;">Next project</router-link>
            </h2>
          </div>
          <FloatingSocials :hoverColor="projects[4].dot" />
          <FloatingText />
          <FloatingContact />
          <BackToTop />
        </div>
      </section>
    </div>
  </ScrollProgressBar>
</template>


<script>
import projects from "@/assets/projects";
import ComponentPizzaBox from "@/components/inner-components/ComponentPizzaBox";
import Menu from "@/components/small-components/Menu";
import FloatingSocials from "@/components/small-components/FloatingSocials";
import FloatingText from "@/components/small-components/FloatingText";
import CaseContact from "@/components/small-components/CaseContact";
import FloatingContact from "@/components/small-components/FloatingContact";
import BackToTop from "@/components/small-components/BackToTop";
import ScrollProgressBar from "@/components/small-components/ScrollProgressBar";
import mixColor from "@/js/functions";

import AOS from "aos";
import "aos/dist/aos.css";

export default {
  name: "ProjectPizzaBox",
  data() {
    return {
      projects: projects,
      activeSectionTitle: 0,
      isWhite: true,
      prevBg: "",
      isScrolling: "",
      activeSection: 0,
      activeSectionMenuColor: "",
      showChild: true,
      showTeam: false,
      sections: [
        {
          absoluteIndex: 0
        }
      ]
    };
  },
  mounted() {
    this.checkMenuActive();
    this.scrollDownDominos();
  },
  watch: {
    isScrolling: function() {
      if (this.isScrolling == false) {
        window.onscroll = function() {};
      } else {
        window.onscroll = function() {
          window.scrollTo(0, 0);
        };
      }
    }
  },
  methods: {
    checkMenuActive: function() {
      if (this.isScrolling == true) {
        window.onscroll = function() {
          window.scrollTo(0, 0);
        };
      } else {
        window.onscroll = function() {};
      }
    },
    scrollDownDominos: function() {
      var scrollY;

      window.addEventListener("scroll", function() {
        scrollY = $(window).scrollTop();

        $("#phone-box").css(
          "-webkit-transform",
          "translateY(" + scrollY * -0.5 + "px)"
        );
        $("#phone-box").css(
          "-ms-transform",
          "translateY(" + scrollY * -0.5 + "px)"
        );
        $("#phone-box").css(
          "-o-transform",
          "translateY(" + scrollY * -0.5 + "px)"
        );
        $("#phone-box").css(
          "transform",
          "translateY(" + scrollY * -0.5 + "px)"
        );

        $("#big-leaves-box").css(
          "-webkit-transform",
          "translateY(" + scrollY * 0.3 + "px)"
        );
        $("#big-leaves-box").css(
          "-ms-transform",
          "translateY(" + scrollY * 0.3 + "px)"
        );
        $("#big-leaves-box").css(
          "-o-transform",
          "translateY(" + scrollY * 0.3 + "px)"
        );
        $("#big-leaves-box").css(
          "transform",
          "translateY(" + scrollY * 0.3 + "px)"
        );
      });
    }
  },
  created() {
    setTimeout(function() {
      AOS.refresh();
    }, 1000);
    setTimeout(function() {
      mixColor();
    }, 1000);
  },
  destroyed() {},
  components: {
    ComponentPizzaBox,
    ScrollProgressBar,
    Menu,
    FloatingSocials,
    FloatingText,
    CaseContact,
    FloatingContact,
    BackToTop
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ProjectPizzaBox.vue